import { ITechnicians } from '@core/interfaces/technicians-items';
import { IWorkOrderItems } from '@core/interfaces/work-order-items-items';

export enum CalendarEventTypeEnum {
  CALL_OUT = 'call_out',
  BREAK = 'break',
  TRAVEL = 'travel',
  SUPPLY_RUN = 'supply_run',
}

export const CalendarEventTypeHuman = {
  [CalendarEventTypeEnum.BREAK]: 'Pause',
  [CalendarEventTypeEnum.CALL_OUT]: 'Intervention',
  [CalendarEventTypeEnum.SUPPLY_RUN]: 'Récup matériel',
  [CalendarEventTypeEnum.TRAVEL]: 'Trajet',
};

export interface ICalendarEvent {
  id: number;
  code: string;
  start_date: string;
  end_date: string;
  event_type: CalendarEventTypeEnum;
  technician: ITechnicians;
  title: string;
  duration?: number;
  work_order_item?: IWorkOrderItems;
}
